export function toFixedTrimTrailing(value: number, fixedLength: number) {
  return value.toFixed(fixedLength).replaceAll(/0+$/g, '').replaceAll(/\.$/g, '');
}

/**
 * Truncates `value` to the `sigFigs` number of significant digits.
 */
export function toPrecision(value: number, sigFigs: number): number {
  return Number(value.toPrecision(sigFigs));
}
